import { useGetFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

export type FetchDictionariesListResponseType = string[];

export const useGetDictionariesList = () =>
  useGetFetch<FetchDictionariesListResponseType>({ url: pathToUrl(ApiRoutesEnum.getDictionaries) });
